import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import MediaQuery from 'react-responsive';
import { Fill } from 'react-slot-fill';
import { Redirect } from 'react-router-dom';
import Modal from '../Modal';
import styles from './MergeRequestModal.css';
import MergeRequestForm from './MergeRequestForm';

const MergeRequestModal = ({
    open,
}) => (<MediaQuery maxWidth={600}>
    {mobile => (mobile ? [
        open ? <Redirect to="/more-info" key="redirect" /> : null,
        <Fill
            name="modal-more-info"
            key="page"
        >
            {open ? <div className={styles.content}>
                <MergeRequestForm form="merge-request-mobile" />
            </div> : null}
        </Fill>,
    ] : <Modal
        className={cx(styles.modal, styles.content)}
        fill="modal"
        open={open}
    >
        <MergeRequestForm form="merge-request" />
    </Modal>)}
</MediaQuery>);

MergeRequestModal.propTypes = {
    open: PropTypes.bool,
};

export default connect(({ auth }) => ({
    open: !!auth.mergeRequestModal,
}))(MergeRequestModal);



// WEBPACK FOOTER //
// ./src/client/Components/MergeRequestModal/MergeRequestModal.js